// @flow
import jwt from '../../utils/jwt'

/**
 * Returns whether the user is logged in.
 * @return {Promise|Error} A resolved Promise with the boolean response or Rejected with an Error
 */
export const isLoggedIn = (): boolean =>
  // TODO: This will be done checking the JWT token for now, which could fail in some cases.
  // BE is going to build a new user state check session soon.
  jwt.isAuthenticated()

export default isLoggedIn
